import * as types from "../types/customerPrintTemplate"

const initialState = []

const customerPrintTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_CUSTOMER_PRINT_TEMPLATE:
      return action.components
    case types.UPDATE_CUSTOMER_PRINT_TEMPLATE:
      return action.components
    default:
      return state
  }
}

export default customerPrintTemplateReducer